import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/full-logo.svg';
import { Separator } from '../Separator';
import { AsideWidgets, WidgetType } from '../AsideWidgets';
import { useMainContext } from '../../context/MainContext';
import { ShareModal } from '../modals/ShareModal';
import { SupportModal } from '../modals/SupportModal';
import { TutorialModal } from '../modals/TutorialModal';
import { Router } from '../../router/Router';

const Menu = styled.aside<{ isMobileMenuOpen: boolean }>`
    width: 180px;
    background: white;
    margin-right: 40px;
    padding-block: 30px;
    padding-left: 20px;
    transition: transform 0.3s ease-in-out;
    
    @media screen and (max-width: 768px) {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 250px;
        margin-right: 0;
        z-index: 999;
        transform: ${props => props.isMobileMenuOpen ? 'translateX(0)' : 'translateX(-100%)'};
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    }
`;

const Logo = styled.img`
    width: 70%;
`;

interface Props {
  selectedTab?: WidgetType;
  isMobileMenuOpen?: boolean;
  onCloseMobileMenu?: () => void;
}

export const AsideMenu: FC<Props> = ({ 
  selectedTab = 'HOME', 
  isMobileMenuOpen = false, 
  onCloseMobileMenu 
}) => {
  const navigation = useNavigate();
  const { profile } = useMainContext();

  const [shareModalVisible, setShareModalVisible] = useState<boolean>(false);
  const [supportModalVisible, setSupportModalVisible] = useState<boolean>(false);
  const [tutorialModalVisible, setTutorialModalVisible] = useState<boolean>(false);

  const handleAsideHome = () => {
    Router(navigation).goToHome(false);
    onCloseMobileMenu?.();
  };
  const handleAsideTutorial = () => {
    setTutorialModalVisible((prevState) => !prevState);
    onCloseMobileMenu?.();
  };
  const handleAsideSupport = () => {
    setSupportModalVisible((prevState) => !prevState);
    onCloseMobileMenu?.();
  };
  const handleAsideShare = () => {
    setShareModalVisible((prevState) => !prevState);
    onCloseMobileMenu?.();
  };
  const handleDashboard = () => {
    Router(navigation).goToDashboard();
    onCloseMobileMenu?.();
  };

  const renderCubeTechnicianOptions = () => {
    if (profile?.groups.includes('cube_technician')) {
      return (
        <>
          <Separator size="XS" />
          <AsideWidgets
            type="DASHBOARD"
            title="Dashboard"
            isSelected={selectedTab === 'DASHBOARD'}
            onClick={handleDashboard}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      <Menu isMobileMenuOpen={isMobileMenuOpen}>
        <Logo src={logo} alt="logo" />
        <Separator size="M" />
        <AsideWidgets type="HOME" title="Home" isSelected={selectedTab === 'HOME'} onClick={handleAsideHome} />
        <Separator size="XS" />
        <AsideWidgets
          type="TUTORIAL"
          title="Tutorial"
          isSelected={selectedTab === 'TUTORIAL'}
          onClick={handleAsideTutorial}
        />
        <Separator size="XS" />
        <AsideWidgets
          type="SUPPORT"
          title="Support"
          isSelected={selectedTab === 'SUPPORT'}
          onClick={handleAsideSupport}
        />
        <Separator size="XS" />
        <AsideWidgets type="SHARE" title="Share" isSelected={selectedTab === 'SHARE'} onClick={handleAsideShare} />
        {renderCubeTechnicianOptions()}
      </Menu>
      {shareModalVisible && <ShareModal onCancel={handleAsideShare} />}
      {supportModalVisible && <SupportModal onCancel={handleAsideSupport} />}
      {tutorialModalVisible && <TutorialModal onClose={handleAsideTutorial} />}
    </>
  );
};
